module.exports = __webpack_public_path__ + "img/sample_map1.7a3a4422.png";